import { Component, inject, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../../services/authentication.service';
import { ActivatedRoute, Router, RouterStateSnapshot } from '@angular/router';

@Component({
  selector: 'app-auth',
  standalone: true,
  imports: [],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.css'
})
export class AuthComponent implements OnInit{

  private authService = inject(AuthenticationService)
  private router: Router = inject(Router);
  private route: ActivatedRoute = inject(ActivatedRoute)

  ngOnInit(): void {
    console.log("ngOnInit AuthComponent")
    if (this.authService.isAuthenticated()) {
      const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
      this.router.navigate([returnUrl]);
    } else {
      this.router.navigate(['/login']);
    }
  }

}
